import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { FormLabel, FormGroup } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CheckBox from "../Forms/CheckboxWithLabel";

import { styles } from "./styles";

const CheckStatusFilter = (props) => {
  const { classes, onSearchCriteriaChange } = props;
  const { t } = useTranslation();
  const [cancelled, setCancelled] = useState(false);
  const [kycComplete, setKycComplete] = useState(false);
  const [amlComplete, setAmlComplete] = useState(false);
  const [kycExpired, setKycExpired] = useState(false);
  const [kycExpiring, setKycExpiring] = useState(false);
  const [amlExpired, setAmlExpired] = useState(false);
  const [amlExpiring, setAmlExpiring] = useState(false);

  const [selected, setSelected] = useState({});

  const handleCancelledChange = (e) => {
    setCancelled(e.target.checked);
    let newState;
    if (e.target.checked) {
      setKycComplete(false);
      setAmlComplete(false);
      setKycExpired(false);
      setKycExpiring(false);
      setAmlExpired(false);
      setAmlExpiring(false);
      newState = { cancelled: true };
    } else {
      newState = { ...selected, cancelled: false };
    }
    setSelected(newState);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkStatuses: newState });
    }
  };

  const handleKycCompleteChange = async (e) => {
    setKycComplete(e.target.checked);
    let newState;
    if (e.target.checked) {
      setCancelled(false);
      newState = { ...selected, kycComplete: true, cancelled: false };
    } else {
      setKycExpired(false);
      setKycExpiring(false);
      newState = { ...selected, kycComplete: false, kycExpired: false, kycExpiring: false };
    }
    setSelected(newState);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkStatuses: newState });
    }
  };

  const handleAmlCompleteChange = async (e) => {
    setAmlComplete(e.target.checked);
    let newState;
    if (e.target.checked) {
      setCancelled(false);
      newState = { ...selected, amlComplete: true, cancelled: false };
    } else {
      setAmlExpired(false);
      setAmlExpiring(false);
      newState = { ...selected, amlComplete: false, amlExpired: false, amlExpiring: false };
    }
    setSelected(newState);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkStatuses: newState });
    }
  };

  const handleKycExpiredChange = async (e) => {
    setKycExpired(e.target.checked);
    const newState = { ...selected, kycExpired: e.target.checked };
    setSelected(newState);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkStatuses: newState });
    }
  };

  const handleKycExpiringChange = async (e) => {
    setKycExpiring(e.target.checked);
    const newState = { ...selected, kycExpiring: e.target.checked };
    setSelected(newState);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkStatuses: newState });
    }
  };

  const handleAmlExpiredChange = async (e) => {
    setAmlExpired(e.target.checked);
    const newState = { ...selected, amlExpired: e.target.checked };
    setSelected(newState);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkStatuses: newState });
    }
  };

  const handleAmlExpiringChange = async (e) => {
    setAmlExpiring(e.target.checked);
    const newState = { ...selected, amlExpiring: e.target.checked };
    setSelected(newState);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ checkStatuses: newState });
    }
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>{t("labels.filter.checkStatus")}</FormLabel>
      <FormGroup>
        <div className={classes.checkBoxContainer}>
          <CheckBox
            label={t("labels.filter.cancelled")}
            onChange={handleCancelledChange}
            value={cancelled}
          />
        </div>
        <div className={classes.checkBoxContainer}>
          <CheckBox
            label={t("labels.filter.kycComplete")}
            onChange={handleKycCompleteChange}
            value={kycComplete}
          />
        </div>
        <div className={classes.checkBoxContainerInner}>
          <CheckBox
            label={t("labels.filter.expired")}
            onChange={handleKycExpiredChange}
            value={kycExpired}
            disabled={!kycComplete}
          />
        </div>
        <div className={classes.checkBoxContainerInner}>
          <CheckBox
            label={t("labels.filter.aboutToExpireIn90Days")}
            onChange={handleKycExpiringChange}
            value={kycExpiring}
            disabled={!kycComplete}
          />
        </div>
        <div className={classes.checkBoxContainer}>
          <CheckBox
            label={t("labels.filter.amlComplete")}
            onChange={handleAmlCompleteChange}
            value={amlComplete}
          />
        </div>
        <div className={classes.checkBoxContainerInner}>
          <CheckBox
            label={t("labels.filter.expired")}
            onChange={handleAmlExpiredChange}
            value={amlExpired}
            disabled={!amlComplete}
          />
        </div>
        <div className={classes.checkBoxContainerInner}>
          <CheckBox
            label={t("labels.filter.aboutToExpireIn90Days")}
            onChange={handleAmlExpiringChange}
            value={amlExpiring}
            disabled={!amlComplete}
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(CheckStatusFilter);
